import React, { FC, MouseEventHandler } from 'react';

import styled from 'styled-components';

import { Col } from '@components/formStyles';
import CustomIcon from '@components/utils/CustomIcon';
import { PhoneIcon, Notes } from '@assets/icons';

export enum AlertType {
  PRIMARY = 'Primary',
  SECONDARY = 'Secondary',
}

export interface AlertProps {
  title?: string;
  description?: string;
  type?: AlertType;
  onClick: MouseEventHandler;
}

const Wrapper = styled.div<{ color: AlertType }>`
  width: 100%;
  height: auto;
  padding: 9px 0 0;
  border-radius: 2px;
  ${({ color }) =>
    color === AlertType.PRIMARY
      ? `background-color: rgba(128, 54, 229, 0.1);`
      : `background-color: rgba(254, 151, 57, 0.1);`}
  position: relative;
  text-align: center;
`;

const Title = styled.span<{ color: AlertType }>`
  margin: 0 10px 3px;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  color: ${({ theme, color }) =>
    color === AlertType.PRIMARY
      ? theme.palette.bluishPurple
      : theme.palette.fadedOrange};
`;

const SubTitle = styled.span<{ color: AlertType }>`
  width: 95%;
  margin: 3px 10px 0;
  font-size: 12px;
  text-align: center;
  color: ${({ theme, color }) =>
    color === AlertType.PRIMARY
      ? theme.palette.bluishPurple
      : theme.palette.fadedOrange};
`;

const Button = styled.button<{ color: AlertType }>`
  width: 100%;
  min-height: 33px;
  margin: 9px 0 0;
  border-radius: 2px;
  display: flex;
  align-items: center;
  display: flex;
  justify-content: center;
  border: none;
  cursor: pointer;
  background-color: ${({ theme, color }) =>
    color === AlertType.PRIMARY
      ? theme.palette.bluishPurple
      : theme.palette.fadedOrange};
  :focus {
    outline: none;
  }
`;

const ButtonText = styled.span<{ color: AlertType }>`
  margin-left: 10px;
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.white};
  text-decoration: underline;
`;

const Alert: FC<AlertProps> = ({
  title = '',
  description = '',
  type = AlertType.PRIMARY,
  onClick = () => false,
}) => (
  <Wrapper color={type}>
    <Col>
      <Title color={type}>{title}</Title>
      <SubTitle color={type}>{description}</SubTitle>
      <Button color={type} onClick={onClick}>
        <CustomIcon
          fill='white'
          icon={type === AlertType.PRIMARY ? PhoneIcon : Notes}
        />
        <ButtonText color={type}>
          {type === AlertType.PRIMARY ? 'Sizi Arayalım' : 'Kontenjan Talep Et'}
        </ButtonText>
      </Button>
    </Col>
  </Wrapper>
);

export default Alert;
